// Directly reference and pull in styling from stub,
// that is commented out in production to elimited 'fake'
// stub javascript while having single source of truth for LESS
require("../stubs/commerceDrawer/commerceDrawer.less");

const $ = require('jquery');
import run from '../../utilities/run';
import {swapClassesViaBool} from "../../utilities/selectorHelpers";
import {bindHardSubmit} from "../../utilities/submitHelpers";
 // For quick dev prototyping
 run("#p_p_id_helpdrawerportlet_WAR_commerceuportlet_", ()=>{
 	attachCommerceDrawer();
 });

 function attachCommerceDrawer(){
 	const commerceDrawerOpen = $('.commerce-drawer');
 	const commerceDrawerOverlay = $('.commerce-overlay');

  // if you click on "open drawer" button the overlay
  // appears and drawer opens
  $('.commerce-drawer-btn').click(function(e) {
  	e.preventDefault();
  	commerceDrawerOpen.addClass('drawer-open');
  	commerceDrawerOverlay.toggle();
  	$('body').addClass('commerce-drawer-open');
  });

  // X button in drawer or clicking out of
  // drawer closes drawer and hides overlay
  $('.commerce-drawer-header .q-drawer-close-x, .commerce-overlay').click(function(e) {
  	e.preventDefault();
  	commerceDrawerOpen.removeClass('drawer-open');
  	commerceDrawerOverlay.toggle();
  	$('body').removeClass('commerce-drawer-open');
  });

  // to flip the expand compress icons within drawer
  $('.commerce-drawer-title-expander').click(function(e) {
  	e.preventDefault();
  	let currentCompress = commerceDrawerOpen.find(".fa-compress");

  	$(this).next('.commerce-drawer-wrapper').toggle();

  	const icon = $(this).find('.expand-icon');
  	const isOpen = !icon.hasClass('fa-expand');
  	swapClassesViaBool(icon, "fa-expand", "fa-compress", isOpen);
  	swapClassesViaBool(currentCompress, "fa-expand", "fa-compress", true);
  	currentCompress.closest(".commerce-drawer-title").next().hide();
  });

  //Submit search 
  bindHardSubmit({
    form: $('.commerce-drawer-search-form'),  
    links: $('.commerce-drawer-search')
  });
}


// WEBPACK FOOTER //
// ./src/pages/commerceDrawer/commerceDrawer.js